import { CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { clockOf } from "./rules/format";
import Shot from "./Shot";

/*
 * A capture, large, over the room. ← / → step through the captures, Esc closes
 * (both through the room's keys); a click outside closes it.
 */
export default function Lightbox({ item, url, index, total, module, lines = [], onStep, onClose, onImageError }) {
  if (!item) return null;
  return (
    <div className="proctoring-review__lightbox" role="dialog" aria-modal="true" aria-label={`Capture at ${clockOf(item.at)}`} onClick={onClose}>
      <div className="proctoring-review__lb-frame" onClick={(e) => e.stopPropagation()} role="presentation">
        <button type="button" className="proctoring-review__lb-close" onClick={onClose} aria-label="Close"><CloseOutlined /></button>
        <div className={`proctoring-review__lb-img${item.flagged ? ` proctoring-review__shot--${item.severity}` : ""}`}>
          <Shot url={url} alt={item.what} onError={onImageError} />
        </div>
        <div className="proctoring-review__lb-info">
          <i className={`proctoring-review__sev proctoring-review__sev--${item.severity}`} />
          <b>{item.what}</b>
          <span>{`${clockOf(item.at)}${module ? ` · ${module}` : ""} · capture ${index + 1} of ${total}`}</span>
          <span className="proctoring-review__grow" />
          <button type="button" className="proctoring-review__lb-nav" onClick={() => onStep(-1)} disabled={index <= 0} aria-label="Previous capture"><LeftOutlined /></button>
          <button type="button" className="proctoring-review__lb-nav" onClick={() => onStep(1)} disabled={index >= total - 1} aria-label="Next capture"><RightOutlined /></button>
        </div>
        {lines.length > 0 && (
          <div className="proctoring-review__lb-lines">
            {lines.map((l) => <p key={l}>{l}</p>)}
          </div>
        )}
      </div>
    </div>
  );
}
